import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import { useTranslation } from "react-i18next";
import { Row } from "reactstrap";
import { TreeSelect, message } from 'antd';
import type { Key } from 'react';

export interface Props {
  formik: any;
  dataRegions?: any
}

registerLocale("en", en);
registerLocale("ko", ko);

const RegionSection = ({ formik, dataRegions }: Props) => {
  const { t } = useTranslation();
  const [lstRegion1, setLstRegion1] = useState<any>([]);
  const [selectedValues, setSelectedValues] = useState([]);

  const formatRegionArray = (arr: any) => {
    return arr.map((item: any) => {
      if (typeof item === 'string' && item.includes('-')) {
        const [regionId, subRegionId] = item.split('-').map(Number);
        return { regionId, subRegionId };
      }

      return { regionId: Number(item) };
    });
  };

  const handleChange = (newValues: any) => {
    if (newValues.length > 3) {
      message.warning({
        content: t('You can select up to 3 items only.'),
        key: 'max-select-warning',
      });
      return;
    }

    let formatValueRegion = [];
    if(newValues?.length > 0) {
      formatValueRegion = formatRegionArray(newValues);
    }
    formik?.setFieldValue("regions", formatValueRegion)
    setSelectedValues(newValues);
  };

  const getParentKeysFromSelected = (selected: (string | number)[]): Key[] => {
    const parentKeys: Set<Key> = new Set();
    selected?.forEach((val) => {
      if (typeof val === "string" && val.includes("-")) {
        const [parentKey] = val.split("-");
        parentKeys.add(parentKey);
      }
    });

    return Array.from(parentKeys);
  };

  const [expandedKeys, setExpandedKeys] = useState<Key[]>([]);
  useEffect(() => {
    const parentKeys = getParentKeysFromSelected(selectedValues);
    setExpandedKeys(parentKeys);
  }, [selectedValues]);

  useEffect(() => {
    if(dataRegions?.length > 0) {
      setLstRegion1(dataRegions?.map((item: any) => {
        return {
          title: item?.label,
          value: String(item?.value),
          children: item?.children?.map((sub: any) => ({
            title: sub?.label,
            value: `${item?.value}-${sub?.value}`
          }))
        }
      }));
    }
  }, [dataRegions]);

  useEffect(() => {
    if(formik?.values?.regions?.length > 0) {
      const formatRegions = formik?.values?.regions?.map((item: any) => {
        if(item?.regionId) {
          return item?.subRegionId ? `${item?.regionId}-${item?.subRegionId}` : String(item?.regionId);
        }
      })
      setSelectedValues(formatRegions)
    }
  }, [formik?.values?.regions])

  const findMatchedParentKeys = (treeData: any[], input: string): Key[] => {
    const matchedParentKeys = new Set<Key>();

    const dfs = (nodes: any[], parentKey: Key | null = null) => {
      nodes.forEach((node) => {
        const title = node.title as string;
        if (title.includes(input) && parentKey !== null) {
          matchedParentKeys.add(parentKey);
        }
        if (node.children) {
          dfs(node.children, node.value);
        }
      });
    };

    dfs(treeData);
    return Array.from(matchedParentKeys);
  };

  return (
    <React.Fragment>
      <div
        className="d-flex flex-column mb-4 pt-3 pb-1 px-3 position-relative"
        style={{
          border: "1px dashed var(--vz-primary)",
          borderRadius: "4px",
        }}
      >
        <span
          className="text-primary position-absolute fs-13 px-1"
          style={{
            backgroundColor: "var(--vz-secondary-bg)",
            top: "0px",
            transform: "translateY(-50%)",
          }}
        >
          {t("Job posting display area")}
        </span>
          <Row className="mb-3 mt-1">
            <TreeSelect
              treeLine={true}
              style={{ width: "100%", height: "38px" }}
              treeData={lstRegion1}
              multiple
              allowClear
              placeholder={t("Please select region")}
              className="dropdown-region-rounded"
              onChange={handleChange}
              value={selectedValues}
              treeExpandedKeys={expandedKeys}
              onTreeExpand={(keys) => setExpandedKeys(keys)}
              onSearch={(val) => {
                if (val) {
                  const parentKeys = findMatchedParentKeys(lstRegion1, val);
                  setExpandedKeys(parentKeys);
                } else {
                  setExpandedKeys([]);
                }
              }}
              filterTreeNode={(input, node) =>
                (node?.title as string)?.includes(input)
              }
            />
        </Row>
      </div>
    </React.Fragment>
  );
};

export default RegionSection;
